import React,{useContext} from "react";
import { Context } from '../context/Context'
import Footer from "../components/layout/footer/Footer";
import Navbar from "../components/layout/header/Navbar";
import Layout from "../components/layout/Layout";
import PageHeader from "../components/header/PageHeader";

import WhychooseHts from "../components/Hts/WhychooseHts";
import IntroHts from "../components/Hts/IntroHts";
import WhoisitforHts from "../components/Hts/WhoisitforHts";
import FeaturesHts from "../components/Hts/FeaturesHts";

export default function Hts() {
  const {hts} = useContext(Context)
  const {logo, tagline} = hts
  return (
    <Layout>
      <Navbar darkBg />
      <PageHeader
        image={logo}
        PageTitle={tagline}
        Parent="Blog"
      />
      <WhychooseHts/>
      <IntroHts/>
      <WhoisitforHts/>
      <FeaturesHts/>
      <Footer />
    </Layout>
  );
}
